import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { CUSTOM_PACKAGES_QUERY } from '../queries';

export default function usePackageNameValidation(value) {
  const { data } = useQuery(CUSTOM_PACKAGES_QUERY, {
    fetchPolicy: 'cache-and-network',
  });
  const packages = data?.customPackages;

  const packageWithNameAlreadyExists = useMemo(
    () => packages?.find((pkg) => pkg.name === value),
    [packages, value]
  );

  const takenNames = useMemo(
    () => packages?.map(({ name }) => name),
    [packages]
  );

  return { packageWithNameAlreadyExists, takenNames };
}
